<template>
  <div class="MaInputClass">
    <el-input
      id="input1"
      ref="input"
      size="mini"
      :disabled="true"
      v-model="value1.label"
      @dblclick.native="popClick"
    >
      <span slot="prefix" class="label_sty">{{labelName}} :</span>
      <span v-if="isMust" slot="prefix" class="ismust_sty">*</span>
      <i slot="suffix" v-if="iconSearch" class="el-input__icon el-icon-search" @click="popClick"></i>
    </el-input>
    <el-dialog :title="labelName"  width="450px" append-to-body :visible.sync="choseClass"  @close="clearData">
        <div id="treeBox">
            <el-input placeholder="输入关键字进行过滤"  v-model="filterText" size="mini"></el-input>
            <el-tree class="filter-tree" :data="treeData" :props="defaultProps" :highlight-current="true" default-expand-all :filter-node-method="filterNode" ref="tree2" @current-change="currentTreeChange"></el-tree>
        </div>
        <div class="btn_box  ub ub-ac ub-pe">
            <el-button size="mini" @click="cancelChoose">取消</el-button>
            <el-button type="primary" size="mini" @click="confirmTree">确定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import tool from "@/utils/tool";
export default {
    name: "MaInputClass",
    data() {
        return {
            value1: this.value,//输入框的值
            choseClass:false,//是否弹出分类选项弹框
            filterText:'',//模糊查询text
            treeData:[],//树形图数据
            // 前端模糊匹配树形图配置
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            chooseTreeData:{label:'所有分类',id:0},//选中的树数据
        };
    },
    props: {
        labelName:[String],
        // 输入框数据
        value: [Object],
        // 是否为必须
        isMust:{
            type: Boolean,
            default: false
        },
        // 收索图标是否显示
        iconSearch:{
            type:Boolean,
            default:true
        },
        // 是否可以选择商品分类
        canChoose:{
            type:Boolean,
            default:true
        }
    },
    watch:{
        // 监听数据变化
        value:{
            handler:function(newVal,oldVal){
                this.value1 = newVal;
            },
            deep:true,
        },
        // 监听模糊匹配改变树状图
        filterText(val) {
            this.$refs.tree2.filter(val);
        },
        // 监听弹出框弹出时请求树形图数据
        choseClass:{
            handler:function(newVal,oldVal){
                if(newVal){
                    this.inteTreeData()
                }
            },
        },
    },
    methods: {
        // 点击
        popClick(){
            if(this.canChoose){
                this.choseClass=true
            }else{
                tool.popMessage(this,'修改商品信息不能够选择分类','warning')
            }
        },
        // 关闭选项框时清空树状图数据
        clearData(){
            this.chooseTreeData = {label:'所有分类',id:0};
        },
        // 请求树形图数据
        inteTreeData(){
            let params = {
                user_id: tool.getLocal("userid"),//用户ID
                session_id: tool.getLocal("sessionid"),//用户凭证
            };
            this.request.post("index/Goods/getlist", {'jparams': JSON.stringify(params)}).then(res => {
                this.treeData = res.tree;
            })
        },
        // 树形图模糊匹配（前端）
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        // 树形节点改变时触发事件
        currentTreeChange(data,treeNode){
            // console.log(data,treeNode)
            this.chooseTreeData = data;
        },
        // 取消选择
        cancelChoose(){
            this.$emit('selectChange',this.chooseTreeData);
            this.choseClass = false;
        },
        // 确定选择 
        confirmTree(){
            if(this.chooseTreeData.id){
                this.$emit('selectChange',this.chooseTreeData);
                this.choseClass = false;
            }else{
                tool.popMessage(this,'请选择商品分类','warning')
            }
        }
    },
    mounted() {

    },

};
</script>

<style lang="less">
.MaInputClass{
    #input1:hover{
        cursor: pointer;
    }
    .label_sty {
        color: #333;
        font-size: 12px;
        padding: 0 5px;
        height: 100%;
        line-height: 28px;
        font-weight: bold;
        display: inline-block;
    }
    .ismust_sty{
        color: red;
    }
    .el-input--prefix .el-input__inner {
        padding-left: 75px;
    }
    .el-input.is-disabled .el-input__inner{
        color: #000;
    }
    .el-input.is-disabled .el-input__icon{
        cursor: pointer;
    }
}

#treeBox{
    width: 100%;
    height: 300px;
    overflow: scroll;
}
#treeBox::-webkit-scrollbar{
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Input/MaInputClass/MaInputClass.vue